import { Component, Inject, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { APP_STORE_CONFIG_TOKEN, ScenarioTesterDCR } from '@ddt-web/config';
import { AppStoreConfig, CellData, ComponentData, TableData } from '@ddt-web/data-service';
import { DialogService } from '@ddt-web/dialog';
import { StoreService } from '@ddt-web/store-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as cloneDeep from 'lodash/cloneDeep';
import { first } from 'rxjs/operators';

import { ScenarioService } from '../../services';
import { SimpleScenarioSelectionDialogComponent } from '../simple-scenario-selection-dialog/simple-scenario-selection-dialog.component';

@UntilDestroy()
@Component({
	selector: 'sc-simple-scenarios-table',
	templateUrl: './simple-scenarios-table.component.html',
	styleUrls: ['./simple-scenarios-table.component.scss']
})
export class SimpleScenariosTableComponent implements OnChanges {

	@Input() public data: ComponentData;
	@Input() public dataTabId: string;
	@Input() public dcrName: string;
	@Input() public storeName: string;
	@Input() public defaultScenariosValue: string = ScenarioTesterDCR.DEFAULT_SCENARIOS_VALUE;
	@Input() public defaultScenariosKey: string = ScenarioTesterDCR.DEFAULT_SCENARIOS_KEY;

	public componentTitle: string;
	public componentDCR: Object;
	public asOfDate: string;
	public selectedScenarios: Array<CellData>;
	public allScenarios: Array<CellData>;
	public selectedScenarioKeys: Array<string> = [];
	public defaultScenarioKeys: Array<string> = [];
	public scenariosTableData: TableData;
	public scenarioNameColumnClass: string;
	public scenarioValueColumnClass: string;
	public modalScenarioData: any;

	constructor(
		public contentService: ContentService,
		public scenarioService: ScenarioService,
		private storeService: StoreService,
		private dialogService: DialogService,
		@Inject(APP_STORE_CONFIG_TOKEN)
		private storeConfig: AppStoreConfig
	) { }

	public ngOnChanges(): void {
		if (this.data.success && this.data.portfolioData) {
			this.componentDCR = ScenarioTesterDCR[this.dcrName];
			this.componentTitle = this.contentService.get(this.componentDCR['TITLE_KEY'], this.componentDCR['TITLE_VALUE']);
			this.defaultScenarioKeys = this.contentService.get(this.defaultScenariosKey, this.defaultScenariosValue).split(',');
			this.scenariosTableData = this.data.getTabById(this.dataTabId).tableData[0];
			this.asOfDate = this.data.portfolioData[0].find(column => column.config.id === 'asOfDate').formattedValue;
			if (this.scenariosTableData) {
				const { scenarioNameColumnClass, scenarioValueColumnClass } = this.scenarioService.assignColumnClasses(this.scenariosTableData.headersX);
				this.scenarioNameColumnClass = scenarioNameColumnClass;
				this.scenarioValueColumnClass = scenarioValueColumnClass; this.allScenarios = this.scenariosTableData.headersY;
			}

			this.updateSelectedScenarios();
		}
	}

	public updateSelectedScenarios(): void {
		this.storeService.selectAll(this.storeConfig.userScenarios)
			.pipe(untilDestroyed(this))
			.subscribe(userScenarios => {
				if (userScenarios) {
					this.selectedScenarioKeys = userScenarios[this.storeName];
				}
			});
		// Convert scenario keys to scenarios
		if (this.selectedScenarioKeys && this.selectedScenarioKeys.length) {
			this.selectedScenarios = this.selectedScenarioKeys.map(key => this.allScenarios.find(scenario => scenario.rawValue.toString() === key)).filter((scenario: CellData) => scenario);
		} else {
			// if there are no user selected scenarios, then use the default ones
			this.selectedScenarios = this.defaultScenarioKeys.map(key => this.allScenarios.find(scenario => scenario.rawValue.toString() === key)).filter((scenario: CellData) => scenario);
		}
	}

	public openScenarioSelectionDialog(): void {
		this.modalScenarioData = {
			allScenarios: this.allScenarios,
			selectedScenarios: this.selectedScenarios
		};
		const dialogRef = this.dialogService.open(SimpleScenarioSelectionDialogComponent, { data: this.modalScenarioData });
		dialogRef.afterClosed.pipe(first()).subscribe(scenarioKeys => {
			if (scenarioKeys) {
				this.selectedScenarioKeys = scenarioKeys;
				this.updateSelectedScenarioKeys(this.selectedScenarioKeys);
			}
		});
	}

	private updateSelectedScenarioKeys(scenarioIds: Array<string>): void {
		let userScenariosClone;
		this.storeService.selectAll(this.storeConfig.userScenarios)
			.pipe(untilDestroyed(this))
			.subscribe(state => {
				userScenariosClone = state ? cloneDeep(state) : {};
				userScenariosClone[this.storeName] = scenarioIds;
			});
		this.storeService.upsertOne(this.storeConfig.userScenarios, userScenariosClone);
	}
}
